import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Shirditourpackage() {



    const cardData = {





keyword: "Shirdi Tour Package",

headingDescription: "Sai Shirdi Cab offers a comfortable and flexible Shirdi Tour Package for devotees, families, senior citizens, tourists, and groups planning a complete pilgrimage and sightseeing experience around Shirdi. Customers can choose private chauffeur-driven Sedan, SUV, Ertiga, Innova, Innova Crysta, and other suitable vehicles according to their group size, luggage, and itinerary. The tour can be customized for temple visits, nearby pilgrimage destinations, Maharashtra sightseeing, one-day excursions, multi-day journeys, and return travel. With experienced drivers, clean and well-maintained vehicles, comfortable seating, flexible pickup and drop arrangements, and convenient travel planning, Sai Shirdi Cab makes it easier to explore Shirdi and nearby destinations at a relaxed pace. Travelers can also include important religious, historical, and scenic places around Maharashtra as part of a personalized tour package.",

topPlaces: [
  {
    title: "Shani Shingnapur",
    description: "Shani Shingnapur is one of the most popular pilgrimage destinations to include in a Shirdi tour package. The sacred Shani temple attracts devotees throughout the year and can be covered conveniently as a day excursion from Shirdi. Sai Shirdi Cab provides private transportation with flexible departure and return timings for families and groups."
  },
  {
    title: "Grishneshwar",
    description: "Grishneshwar is home to one of the twelve revered Jyotirlinga temples of Lord Shiva and is an important religious destination for devotees touring Maharashtra. Travelers can combine Grishneshwar with Ellora and other nearby attractions in a customized Shirdi tour. Comfortable private cabs make the multi-destination journey convenient."
  },
  {
    title: "Saptashrungi",
    description: "Saptashrungi Gad near Vani is an important Shakti pilgrimage destination surrounded by the Sahyadri ranges. Devotees can add Saptashrungi to their Shirdi tour itinerary for an extended religious journey. Customers can travel in a private cab with flexible timings and include additional temples or sightseeing locations along the route."
  },
  {
    title: "Trimbakeshwar",
    description: "Trimbakeshwar is a major pilgrimage destination near Nashik and is renowned for its ancient Jyotirlinga Temple. It is a suitable addition to a Shirdi tour package for devotees interested in visiting important Shiva temples. Sai Shirdi Cab provides comfortable transportation and customized multi-stop travel arrangements for families and groups."
  },
  {
    title: "Nashik",
    description: "Nashik is a prominent religious and cultural city that offers temples, heritage attractions, scenic locations, and other places of interest. Travelers can include Nashik in their Shirdi tour for a broader Maharashtra sightseeing experience. Private cab service allows customers to organize the itinerary around their preferred travel schedule."
  },
  {
    title: "Aurangabad",
    description: "Aurangabad, officially known as Chhatrapati Sambhajinagar, is a major heritage destination that can be combined with a Shirdi tour package. Travelers can explore historic monuments, caves, temples, and cultural attractions during an extended itinerary. Spacious Innova and Innova Crysta vehicles are suitable for families and groups."
  },
  {
    title: "Ellora Caves",
    description: "Ellora Caves are a remarkable heritage attraction near Grishneshwar and are an excellent addition to a religious and sightseeing tour from Shirdi. The ancient rock-cut monuments provide a memorable cultural experience for tourists and families. Customers can conveniently combine Ellora with Grishneshwar through a customized private cab itinerary."
  },
  {
    title: "Paithan",
    description: "Paithan is a historic Maharashtra destination known for its religious importance, temples, cultural heritage, and traditional Paithani craftsmanship. Travelers looking for a wider regional tour can include Paithan in their Shirdi itinerary. Sai Shirdi Cab offers flexible private transportation for families and groups visiting multiple destinations."
  }
],





  "services": [
    {
      "name": "Shirdi Tour Package",
      "description": "Shirdi Tour Package offers convenient travel arrangements for visitors planning a comfortable trip to Shirdi. Cab transportation can be arranged for Sai Baba Darshan, local sightseeing, nearby temples, hotels, railway stations, and surrounding destinations according to the travel schedule."
    },
    {
      "name": "Shirdi Travel Package",
      "description": "Shirdi Travel Package provides a practical option for travelers looking to explore Shirdi with private cab transportation. The package can be planned for temple visits, local attractions, nearby pilgrimage destinations, family travel, and convenient return journeys."
    },
    {
      "name": "Shirdi Holiday Package",
      "description": "Shirdi Holiday Package is suitable for families and travelers combining spiritual visits with local sightseeing. Comfortable cabs can be arranged for Shirdi temple visits, nearby attractions, hotel transfers, and additional destinations based on the number of days planned."
    },
    {
      "name": "Shirdi Darshan Package",
      "description": "Shirdi Darshan Package helps pilgrims plan transportation for a convenient Sai Baba temple visit. Private cab services can be arranged for pickup, temple transfers, hotel travel, and return journeys while allowing travelers to manage their darshan schedule comfortably."
    },
    {
      "name": "Shirdi Sai Baba Tour Package",
      "description": "Shirdi Sai Baba Tour Package is designed for devotees visiting the Sai Baba Temple and other important places in Shirdi. Cab transportation can cover hotel pickup, temple visits, local sightseeing, railway station transfers, and nearby pilgrimage destinations."
    },
    {
      "name": "Sai Baba Shirdi Package",
      "description": "Sai Baba Shirdi Package provides private transportation support for devotees planning a spiritual journey to Shirdi. Travelers can arrange comfortable cabs for Sai Baba Darshan, local temple visits, accommodation transfers, and nearby sightseeing according to their itinerary."
    },
    {
      "name": "Shirdi Temple Tour Package",
      "description": "Shirdi Temple Tour Package allows visitors to explore important temples and spiritual attractions around Shirdi by private cab. The service can be planned for families, senior citizens, groups, and individual travelers requiring flexible temple and sightseeing transportation."
    },
    {
      "name": "Shirdi Yatra Package",
      "description": "Shirdi Yatra Package provides cab transportation for pilgrims traveling to Shirdi for religious visits. Depending on the itinerary, the journey can include Sai Baba Darshan, nearby temples, pilgrimage locations, hotel transfers, and convenient return transportation."
    },
    {
      "name": "Shirdi Pilgrimage Package",
      "description": "Shirdi Pilgrimage Package is suitable for devotees planning a spiritual trip with private transportation. Cab arrangements can include Shirdi temple visits and nearby pilgrimage destinations while providing flexible travel options for families and groups."
    },
    {
      "name": "Shirdi Trip Package",
      "description": "Shirdi Trip Package offers a convenient way to organize transportation for a short or extended visit to Shirdi. Customers can plan cab travel for temple Darshan, local sightseeing, hotel transfers, railway station pickups, and nearby destinations."
    },
    {
      "name": "Shirdi Tourism Package",
      "description": "Shirdi Tourism Package combines local sightseeing and comfortable cab transportation for travelers exploring the town and its surrounding attractions. The itinerary can be customized for temples, spiritual landmarks, local points of interest, and nearby outstation destinations."
    },
    {
      "name": "Shirdi Family Tour Package",
      "description": "Shirdi Family Tour Package provides comfortable private transportation for families visiting Shirdi together. Spacious vehicles can be arranged for Sai Baba Darshan, hotel transfers, local sightseeing, nearby temples, and additional destinations according to family travel requirements."
    },
    {
      "name": "Shirdi Tour by Cab",
      "description": "Shirdi Tour by Cab offers private transportation for travelers who prefer a flexible sightseeing experience. The cab can be used for Sai Baba Temple visits, local attractions, nearby pilgrimage locations, railway station transfers, and return travel."
    },
    {
      "name": "Best Shirdi Tour Package",
      "description": "Best Shirdi Tour Package is suitable for travelers seeking a well-planned private cab journey to Shirdi. Vehicle options can be selected according to passenger requirements, with transportation available for temple visits, sightseeing, hotel transfers, and nearby destinations."
    },
    {
      "name": "Affordable Shirdi Tour Package",
      "description": "Affordable Shirdi Tour Package provides practical cab travel options for visitors planning a budget-conscious trip. Customers can choose an appropriate vehicle and itinerary for Sai Baba Darshan, local sightseeing, hotel transfers, and short-distance pilgrimage travel."
    },
    {
      "name": "One-Day Shirdi Tour Package",
      "description": "One-Day Shirdi Tour Package is designed for travelers who want to complete a Shirdi visit within a single day. Private cab transportation can be arranged for temple Darshan, local sightseeing, pickup and drop, and return travel according to the planned schedule."
    },
    {
      "name": "Shirdi One-Day Darshan Package",
      "description": "Shirdi One-Day Darshan Package provides convenient transportation for pilgrims planning a same-day Sai Baba Darshan. Cab service can include pickup from the selected location, temple travel, local transfers, and return transportation after completing the visit."
    },
    {
      "name": "Shirdi 1 Night 2 Days Package",
      "description": "Shirdi 1 Night 2 Days Package gives travelers additional time for Sai Baba Darshan and local sightseeing. Private cab transportation can be arranged for temple visits, hotel transfers, nearby attractions, and return travel throughout the planned two-day itinerary."
    },
    {
      "name": "Shirdi 2 Days 1 Night Package",
      "description": "Shirdi 2 Days 1 Night Package is suitable for families and pilgrims looking for a relaxed Shirdi visit. Cab transportation can cover Sai Baba Temple, local sightseeing, nearby spiritual places, hotel transfers, and convenient travel between destinations."
    },
    {
      "name": "Shirdi 2 Nights 3 Days Package",
      "description": "Shirdi 2 Nights 3 Days Package allows travelers to enjoy a longer spiritual and sightseeing itinerary. Comfortable cab service can be planned for Sai Baba Darshan, nearby temples, local attractions, hotel transfers, and additional destinations around Shirdi."
    },
    {
      "name": "Shirdi 3 Days 2 Nights Package",
      "description": "Shirdi 3 Days 2 Nights Package provides more flexibility for visitors combining pilgrimage and sightseeing. A private cab can be arranged for temple visits, local attractions, nearby pilgrimage destinations, accommodation transfers, and scheduled return travel."
    },
    {
      "name": "Shirdi 4 Days 3 Nights Package",
      "description": "Shirdi 4 Days 3 Nights Package is suitable for travelers planning an extended pilgrimage and sightseeing journey. The itinerary can include Shirdi, nearby temples, spiritual destinations, local attractions, and outstation locations with private cab transportation."
    },
    {
      "name": "Shirdi 5 Days Tour Package",
      "description": "Shirdi 5 Days Tour Package offers an extended travel plan for visitors who want to explore Shirdi and nearby destinations at a comfortable pace. Cab transportation can be customized for pilgrimage visits, sightseeing, hotel transfers, and multi-day travel."
    },
    {
      "name": "Shirdi Weekend Tour Package",
      "description": "Shirdi Weekend Tour Package is convenient for travelers planning a short spiritual getaway. Private cab arrangements can cover Sai Baba Darshan, local sightseeing, nearby temples, hotel transfers, and return travel within a weekend schedule."
    },
    {
      "name": "Shirdi Same-Day Tour Package",
      "description": "Shirdi Same-Day Tour Package is designed for visitors who want to travel to Shirdi, complete their planned Darshan and sightseeing, and return on the same day. Cab transportation can be organized around the preferred pickup and return schedule."
    },
    {
      "name": "Shirdi Overnight Tour Package",
      "description": "Shirdi Overnight Tour Package provides a convenient travel option for pilgrims who prefer to stay overnight in Shirdi. Cab service can be arranged for temple visits, hotel transfers, local sightseeing, and onward or return journeys."
    },
    {
      "name": "Shirdi Short Trip Package",
      "description": "Shirdi Short Trip Package is suitable for travelers planning a quick pilgrimage or weekend visit. Private cab transportation can be arranged for Sai Baba Darshan, local attractions, hotel transfers, railway station pickups, and nearby destinations."
    },
    {
      "name": "Shirdi Multi-Day Tour Package",
      "description": "Shirdi Multi-Day Tour Package allows travelers to create a flexible itinerary covering Shirdi and surrounding pilgrimage or sightseeing destinations. Cab services can be arranged for multiple days with suitable vehicles for families, groups, and individual travelers."
    },
    {
      "name": "Shirdi Shani Shingnapur Tour Package",
      "description": "Shirdi Shani Shingnapur Tour Package combines visits to Sai Baba Temple in Shirdi and Shani Shingnapur with private cab transportation. The journey can be planned for families and pilgrims requiring convenient transfers between both important religious destinations."
    },
    {
      "name": "Shirdi Nashik Tour Package",
      "description": "Shirdi Nashik Tour Package provides private cab transportation for travelers visiting Shirdi and Nashik together. The itinerary can include Sai Baba Darshan, Nashik temples, Trimbakeshwar, local sightseeing, hotel transfers, and return travel according to the selected package."
    },
    {
      "name": "Shirdi Tour Package from Mumbai 1 Day",
      "description": "Shirdi Tour Package from Mumbai 1 Day is suitable for travelers planning a same-day pilgrimage from Mumbai to Shirdi. A private cab can be arranged for pickup from Mumbai, Sai Baba Darshan in Shirdi, local transfers, and return travel after completing the planned visit."
    },
    {
      "name": "2 Days Trip to Shirdi",
      "description": "2 Days Trip to Shirdi offers travelers enough time for Sai Baba Darshan along with local sightseeing and nearby religious attractions. Private cab transportation can be arranged throughout the itinerary for comfortable transfers between pickup points, hotels, temples, and return destinations."
    },
    {
      "name": "Ajanta Ellora from Shirdi",
      "description": "Ajanta Ellora from Shirdi provides a convenient cab travel option for visitors who want to combine their Shirdi pilgrimage with a visit to the famous Ajanta and Ellora cave sites. The journey can be planned as an extended sightseeing trip with suitable vehicle options."
    },
    {
      "name": "Ajanta Ellora Shirdi Package",
      "description": "Ajanta Ellora Shirdi Package combines spiritual travel to Shirdi with sightseeing at the Ajanta and Ellora caves. Private cab transportation can be arranged for multi-day travel, hotel transfers, temple visits, sightseeing stops, and return journeys."
    },
    {
      "name": "Ajanta Ellora Tour from Shirdi",
      "description": "Ajanta Ellora Tour from Shirdi is suitable for travelers who want to explore Maharashtra's important heritage attractions after visiting Sai Baba Temple. Cab transportation can be customized according to the preferred number of days, vehicle category, and sightseeing itinerary."
    },
    {
      "name": "Ajanta Ellora Tour Packages from Shirdi",
      "description": "Ajanta Ellora Tour Packages from Shirdi provide flexible private cab options for combining pilgrimage and heritage sightseeing. Travelers can plan visits to Ajanta and Ellora with convenient transportation, hotel transfers, sightseeing stops, and return travel."
    },
    {
      "name": "Delhi to Shirdi Package",
      "description": "Delhi to Shirdi Package is suitable for travelers planning a pilgrimage journey from Delhi to Shirdi. Cab transportation can be arranged after reaching the required pickup point for Sai Baba Darshan, local sightseeing, nearby temples, hotel transfers, and onward travel."
    },
    {
      "name": "Delhi to Shirdi Tour",
      "description": "Delhi to Shirdi Tour provides travel support for visitors planning a spiritual journey to Sai Baba Temple. A private cab can be arranged for local Shirdi transportation, temple visits, nearby sightseeing, hotel transfers, and additional pilgrimage destinations."
    },
    {
      "name": "Hyderabad to Shirdi Package",
      "description": "Hyderabad to Shirdi Package offers a convenient travel arrangement for pilgrims visiting Shirdi from Hyderabad. Private cab transportation can be planned for local transfers, Sai Baba Darshan, sightseeing, hotel pickup and drop, and nearby religious destinations."
    },
    {
      "name": "Hyderabad to Shirdi Tour Package",
      "description": "Hyderabad to Shirdi Tour Package is suitable for families and devotees planning a structured trip to Shirdi. Cab arrangements can support local transportation for Sai Baba Temple visits, nearby attractions, accommodation transfers, and onward journeys."
    },
    {
      "name": "Local Tour Operators in Shirdi",
      "description": "Local Tour Operators in Shirdi can assist travelers with private cab transportation and customized sightseeing plans. Services can include local temple visits, Sai Baba Darshan, nearby pilgrimage destinations, railway station transfers, hotel travel, and short local tours."
    },
    {
      "name": "Mumbai and Shirdi Package",
      "description": "Mumbai and Shirdi Package combines travel between Mumbai and Shirdi with convenient private cab transportation. The itinerary can be planned for Sai Baba Darshan, Mumbai pickup and drop, hotel transfers, local sightseeing, and additional destinations as required."
    },
    {
      "name": "Mumbai to Shirdi Darshan Package",
      "description": "Mumbai to Shirdi Darshan Package provides private cab transportation for devotees traveling from Mumbai to Sai Baba Temple. The service can be planned as a same-day or extended trip with comfortable pickup, temple travel, local transfers, and return arrangements."
    },
    {
      "name": "One-Day Trip from Shirdi",
      "description": "One-Day Trip from Shirdi is ideal for travelers who want to explore nearby religious, heritage, or sightseeing destinations within a single day. Private cab service can be arranged according to the selected route, vehicle type, and preferred departure and return timing."
    },
    {
      "name": "Package for Shirdi",
      "description": "Package for Shirdi provides flexible travel arrangements for pilgrims and tourists visiting the destination. Cab transportation can be customized for Sai Baba Darshan, local sightseeing, nearby temples, hotel transfers, railway station pickups, and outstation travel."
    },
    {
      "name": "Shirdi Local Tour Packages",
      "description": "Shirdi Local Tour Packages are designed for visitors who want to explore important attractions within and around Shirdi. Private cabs can be arranged for Sai Baba Temple, Dwarkamai, Chavadi, nearby temples, local sightseeing points, and convenient hotel transfers."
    },
    {
      "name": "Shirdi Local Tour Packages for Family",
      "description": "Shirdi Local Tour Packages for Family provide comfortable private transportation for families exploring Shirdi together. Suitable vehicles can be arranged for temple visits, local attractions, hotel transfers, and nearby pilgrimage destinations while accommodating passenger and luggage requirements."
    }
  ],
  "tableData": [
    ["Shirdi Tour Package", "Shirdi Travel Package"],
    ["Shirdi Holiday Package", "Shirdi Darshan Package"],
    ["Shirdi Sai Baba Tour Package", "Sai Baba Shirdi Package"],
    ["Shirdi Temple Tour Package", "Shirdi Yatra Package"],
    ["Shirdi Pilgrimage Package", "Shirdi Trip Package"],
    ["Shirdi Tourism Package", "Shirdi Family Tour Package"],
    ["Shirdi Tour by Cab", "Best Shirdi Tour Package"],
    ["Affordable Shirdi Tour Package", "One-Day Shirdi Tour Package"],
    ["Shirdi One-Day Darshan Package", "Shirdi 1 Night 2 Days Package"],
    ["Shirdi 2 Days 1 Night Package", "Shirdi 2 Nights 3 Days Package"],
    ["Shirdi 3 Days 2 Nights Package", "Shirdi 4 Days 3 Nights Package"],
    ["Shirdi 5 Days Tour Package", "Shirdi Weekend Tour Package"],
    ["Shirdi Same-Day Tour Package", "Shirdi Overnight Tour Package"],
    ["Shirdi Short Trip Package", "Shirdi Multi-Day Tour Package"],
    ["Shirdi Shani Shingnapur Tour Package", "Shirdi Nashik Tour Package"],
    ["Shirdi Tour Package from Mumbai 1 Day", "2 Days Trip to Shirdi"],
    ["Ajanta Ellora from Shirdi", "Ajanta Ellora Shirdi Package"],
    ["Ajanta Ellora Tour from Shirdi", "Ajanta Ellora Tour Packages from Shirdi"],
    ["Delhi to Shirdi Package", "Delhi to Shirdi Tour"],
    ["Hyderabad to Shirdi Package", "Hyderabad to Shirdi Tour Package"],
    ["Local Tour Operators in Shirdi", "Mumbai and Shirdi Package"],
    ["Mumbai to Shirdi Darshan Package", "One-Day Trip from Shirdi"],
    ["Package for Shirdi", "Shirdi Local Tour Packages"],
    ["Shirdi Local Tour Packages for Family", "Shirdi Tour Package"]
  ],




        whychoose: [
            { 
                WhyChooseheading: "Well-Planned Shirdi Tour Package for Devotees", 
                WhyChoosedescription: "Sai Shirdi Cabs makes Shirdi travel easier with a private tour package designed for devotees, families, senior citizens, couples, and groups. Plan your temple visit, local travel, and nearby sightseeing with transportation arranged around your preferred itinerary." 
            }, 
            { 
                WhyChooseheading: "Pickup from Hotel, Railway Station or Airport", 
                WhyChoosedescription: "Start your Shirdi tour from your hotel, residence, Sainagar Shirdi Railway Station, Shirdi Airport, or another convenient pickup location. Direct pickup helps you save time and keeps your travel arrangements simple." 
            }, 
            { 
                WhyChooseheading: "Convenient Sai Baba Darshan Travel", 
                WhyChoosedescription: "Plan transportation around your Sai Baba Darshan schedule with a dedicated cab. Families and devotees can travel together between their accommodation, temple area, and other planned locations without depending on multiple local transport options." 
            }, 
            { 
                WhyChooseheading: "Local Shirdi Sightseeing Options", 
                WhyChoosedescription: "Along with Sai Baba Temple, travellers can discuss visiting important local attractions and nearby places as part of their tour plan. The itinerary can be adjusted according to the available time and sightseeing preferences." 
            }, 
            { 
                WhyChooseheading: "Comfortable Vehicles for Families & Groups", 
                WhyChoosedescription: "Select a suitable vehicle according to the number of passengers, luggage, and required comfort level. Private transportation allows families, friends, and pilgrimage groups to remain together throughout their Shirdi tour." 
            }, 
            { 
                WhyChooseheading: "Flexible One-Day & Extended Tour Plans", 
                WhyChoosedescription: "Whether you are visiting Shirdi for a short one-day pilgrimage or planning additional nearby destinations, the travel arrangement can be discussed according to your available time, preferred stops, and overall tour requirements." 
            }, 
            { 
                WhyChooseheading: "Nearby Pilgrimage Destinations", 
                WhyChoosedescription: "Travellers can extend their Shirdi tour to nearby religious destinations such as Shani Shingnapur, Saptashrungi, Trimbakeshwar, Grishneshwar, or other preferred places depending on the selected itinerary and available travel time." 
            }, 
            { 
                WhyChooseheading: "Book Shirdi Tour Package with Sai Shirdi Cabs", 
                WhyChoosedescription: "Share your travel dates, pickup location, passenger count, preferred vehicle, Darshan plans, sightseeing requirements, and desired tour duration with Sai Shirdi Cabs to arrange a suitable private cab package." 
            } 
        ] 
 
    }; 
 
    const faqData = [ 
        { 
            question: "What is included in the Shirdi Tour Package?", 
            answer: "The Shirdi Tour Package can include private cab transportation for Sai Baba Darshan, local travel, railway station or airport transfers, and selected nearby sightseeing according to the itinerary discussed during booking." 
        }, 
        { 
            question: "Can I book a private cab for a Shirdi tour?", 
            answer: "Yes, Sai Shirdi Cabs provides private cab arrangements for individuals, couples, families, senior citizens, and pilgrimage groups visiting Shirdi." 
        }, 
        { 
            question: "Can the Shirdi Tour Package include Sai Baba Darshan?", 
            answer: "Yes, transportation can be planned around your Sai Baba Darshan schedule, including pickup from your hotel and travel to the temple area and other planned locations." 
        }, 
        { 
            question: "Can I customize my Shirdi Tour Package?", 
            answer: "Yes, the package can be customized according to your travel dates, passenger count, vehicle preference, sightseeing requirements, trip duration, and nearby destinations you want to visit." 
        }, 
        { 
            question: "Can I include Shani Shingnapur in my Shirdi tour?", 
            answer: "Yes, Shani Shingnapur can be included as an additional pilgrimage destination when planning a suitable itinerary from Shirdi, subject to the available travel time and selected trip arrangement." 
        }, 
        { 
            question: "Can I visit Saptashrungi during the Shirdi Tour Package?", 
            answer: "Yes, travellers can discuss adding Saptashrungi to their pilgrimage itinerary. The travel plan can be arranged according to the desired destinations and number of days available." 
        }, 
        { 
            question: "Is the Shirdi tour suitable for senior citizens?", 
            answer: "Yes, a private cab can be a convenient choice for families travelling with senior citizens because everyone can remain together and the travel schedule can be planned according to the group's requirements." 
        }, 
        { 
            question: "Which vehicles are available for the Shirdi tour?", 
            answer: "Vehicle selection depends on passenger numbers, luggage, and comfort requirements. Suitable car and larger group vehicle options can be discussed during the booking process." 
        }, 
        { 
            question: "Can I book Shirdi Airport or railway station pickup?", 
            answer: "Yes, passengers can arrange pickup or drop transportation between Shirdi Airport, Sainagar Shirdi Railway Station, hotels, residences, and other preferred locations as part of their travel plan." 
        }, 
        { 
            question: "How can I book a Shirdi Tour Package with Sai Shirdi Cabs?", 
            answer: "Share your travel dates, pickup point, passenger details, preferred vehicle, Darshan requirements, sightseeing plans, and expected tour duration with Sai Shirdi Cabs to arrange your private Shirdi tour." 
        } 
    ]; 
 
    const testimonials = [ 
        { 
            id: 1, 
            name: "Mr. Suresh Pawar", 
            feedback: "Our family planned a Shirdi pilgrimage with local sightseeing, and the private cab made the entire trip easier to organize. We could travel together and manage our temple visit according to our schedule.", 
            rating: 5 
        }, 
        { 
            id: 2, 
            name: "Mrs. Meena Kulkarni", 
            feedback: "We visited Shirdi with our parents and wanted comfortable transportation throughout the tour. The cab was useful for our temple visit, local travel, and planned sightseeing with the family.", 
            rating: 5 
        } 
    ];












    const Images = [
        { place: "/images/keyword/1.jpg", text: "Nagarsol to Shirdi Cab", link: "Nagarsol-to-Shirdi-Cab" },
        { place: "/images/keyword/2.jpg", text: "Shirdi Cab Service", link: "Shirdi-Cab-Service" },
        { place: "/images/keyword/3.jpg", text: "Shirdi to Shani Shingnapur Cab", link: "Shirdi-to-Shani-Shingnapur-Cab" },
        { place: "/images/keyword/4.jpg", text: "Shirdi to Grishneshwar Cab", link: "Shirdi-to-Grishneshwar-Cab" },
        { place: "/images/keyword/5.jpg", text: "Shirdi to Manmad Cab", link: "Shirdi-to-Manmad-Cab" },
        { place: "/images/keyword/6.jpg", text: "Shirdi to Lonavala Cab", link: "Shirdi-to-Lonavala-Cab" },
        { place: "/images/keyword/7.jpg", text: "Shirdi to Mahabaleshwar Cab", link: "Shirdi-to-Mahabaleshwar-Cab" },
        { place: "/images/keyword/8.jpg", text: "Shirdi to Ashtavinayak Darshan Package", link: "Shirdi-to-Ashtavinayak-Darshan-Package" },
        { place: "/images/keyword/9.jpg", text: "Shirdi to Saptashrungi Cab", link: "Shirdi-to-Saptashrungi-Cab" },
        { place: "/images/keyword/10.jpg", text: "Shirdi Tour Package", link: "Shirdi-Tour-Package" },
        { place: "/images/keyword/11.jpg", text: "Best Taxi Service in Shirdi", link: "Best-Taxi-Service-in-Shirdi" },
        { place: "/images/keyword/12.jpg", text: "Shirdi Airport Cab Service", link: "Shirdi-Airport-Cab-Service" },
        { place: "/images/keyword/13.jpg", text: "Online Cab Booking Shirdi", link: "Online-Cab-Booking-Shirdi" },
        { place: "/images/keyword/14.jpg", text: "Best Travel Agency in Shirdi", link: "Best-Travel-Agency-in-Shirdi" },
        { place: "/images/keyword/15.jpg", text: "Shirdi to Mumbai Airport Cab", link: "Shirdi-to-Mumbai-Airport-Cab" },
        { place: "/images/keyword/16.jpg", text: "Kopargaon to Shirdi Cab", link: "Kopargaon-to-Shirdi-Cab" },
        { place: "/images/keyword/17.jpg", text: "Innova on Rent in Shirdi", link: "Innova-on-Rent-in-Shirdi" },
        { place: "/images/keyword/18.jpg", text: "Shirdi Sightseeing Cab", link: "Shirdi-Sightseeing-Cab" },
        { place: "/images/keyword/19.jpg", text: "Shirdi Darshan Taxi", link: "Shirdi-Darshan-Taxi" },
        { place: "/images/keyword/20.jpg", text: "Bus on Hire in Shirdi", link: "Bus-on-Hire-in-Shirdi" },
        { place: "/images/keyword/21.jpg", text: "Best Sedan Cab in Shirdi", link: "Best-Sedan-Cab-in-Shirdi" },
        { place: "/images/keyword/22.jpg", text: "Ertiga Car Hire in Shirdi", link: "Ertiga-Car-Hire-in-Shirdi" },
        { place: "/images/keyword/23.jpg", text: "Innova Crysta on Rent in Shirdi", link: "Innova-Crysta-on-Rent-in-Shirdi" },
        { place: "/images/keyword/24.jpg", text: "Mini Bus on Rent in Shirdi", link: "Mini-Bus-on-Rent-in-Shirdi" },
        { place: "/images/keyword/25.jpg", text: "Tempo Traveller Hire in Shirdi", link: "Tempo-Traveller-Hire-in-Shirdi" },
    ];




const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Shirdi Tour Package",
  "image": "https://www.saishirdicabs.com/assets/images/shirdi-tour-package.webp",
  "description":
    "Book Shirdi Tour Package with Sai Shirdi Cabs for comfortable and convenient local and outstation travel. We offer customized Shirdi local tour packages, family tour packages, one-day and two-day Shirdi trips, Mumbai to Shirdi tour packages, and Ajanta Ellora sightseeing packages. Choose from Sedan, Ertiga, SUV, Innova, Innova Crysta, and Tempo Traveller options for temple visits, family holidays, pilgrimage tours, and sightseeing.",
  "brand": {
    "@type": "Brand",
    "name": "Sai Shirdi Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8517"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.saishirdicabs.com/shirdi-tour-package"
  }
};











    return (
        <div>
<Helmet>
  <title>Shirdi Tour Package | Shirdi Trip & Travel Packages | +91 7776814559</title>

  <meta
    name="description"
    content="Book Shirdi Tour Package with Sai Shirdi Cabs for affordable and comfortable Shirdi trips. Choose from local tour packages, family tour packages, Mumbai to Shirdi one-day trips, two-day Shirdi packages, and Ajanta Ellora tours with Sedan, Ertiga, SUV, Innova, Innova Crysta, and Tempo Traveller."
  />

  <meta
    name="keywords"
    content="Shirdi Package, Shirdi Local Tour Packages, Shirdi trip, Shirdi family tour packages, shirdi travel package, shirdi trip package, shirdi tours and travels, shirdi tour package from mumbai 1 day, 2 days trip to shirdi, ajanta ellora from shirdi, ajanta ellora shirdi package, Shirdi Tour Package, Shirdi Travel Package, Shirdi Sightseeing Tour, Shirdi Local Sightseeing Package, Shirdi Family Trip Package, Shirdi One Day Tour Package, Shirdi Two Day Tour Package, Mumbai to Shirdi Tour Package, Mumbai to Shirdi 1 Day Trip, Shirdi Ajanta Ellora Tour Package, Shirdi Temple Tour Package, Shirdi Pilgrimage Tour, Shirdi Car Rental for Tour, Shirdi Tempo Traveller Package"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>



            <section className="page-banner">
                <div className="page-banner-container">
                    <h2>
                        {cardData.keyword}
                    </h2>
                </div>
            </section>


















            <section>
                <div className="container-fluid p-0" >
                    <div className="row container-fluid px-md-2">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/10.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Sai Shirdi Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>

                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>





                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div className="service-card" key={index}>
                                        <div className="service-content">
                                            <h4>{service.name}</h4>
                                            <span className="line"></span>
                                            <p>{service.description}</p>
                                        </div>

                                        <div className="service-icon">
                                            <i className="fas fa-arrow-right"></i>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            <div className="keyword-grid">
                                {cardData.tableData.flat().map((keyword, index) => (
                                    <div key={index} className="keyword-item">
                                        <span className="keyword-bullet">-</span>
                                        {keyword}
                                    </div>
                                ))}
                            </div>



                            <div id="why-choose-section" className="why-choose-section">

                                <h2 className="section-title text-dark">
                                    Why Choose <span>Sai Shirdi Cabs</span>
                                </h2>

                                <div className="bento-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div className="bento-card" key={index}>

                                            <div className="bento-number">
                                                {String(index + 1).padStart(2, "0")}
                                            </div>

                                            <h4>{item.WhyChooseheading}</h4>

                                            <p>{item.WhyChoosedescription}</p>

                                        </div>
                                    ))}
                                </div>

                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sai Shirdi Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fas fa-phone-alt"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+917776814559" className="pc-call">+91 7776814559 </a>
                                        </div>

                                        <div className="pc-list">
                                            <a href="tel:+919579032227" className="pc-call">+91 9579032227 </a>
                                        </div>
                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/91917776814559 "
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+917776814559 " className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-envelope"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@saishirdicabs.com" className="pc-email">
                                            booking@saishirdicabs.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-location-dot"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Sai Shirdi Cabs</strong><br />
                                            Sai Mandir Lene, Near Hotel Sai Kanhaiya,
                                            Shirdi,Tel - Rahata,Dist Ahilyanagar,
                                            Maharashtra, India - 423109




                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Shirditourpackage;